<template>
    <b-form
        @submit.stop.prevent="onSubmit"
        @reset.stop.prevent="onReset"
        v-if="show"
        class="main-form"
    >
        <h2 class="text-center">Editar senha</h2>

        <b-form-group label="Editar senha:">
            
            <b-form-input
                v-model="form.password"
                type="password"
                required
                placeholder="Digite a nova senha"
            ></b-form-input>
        </b-form-group>

        <b-form-group label="Confirmar senha:">

            <b-form-input
                v-model="form.password_confirmation"
                type="password"
                required
                placeholder="Confirme a nova senha"
            ></b-form-input>

        </b-form-group>

        <div class="text-center">
            <b-button type="submit" variant="primary">Salvar nova senha</b-button>
            &nbsp;&nbsp;&nbsp;
            <b-button type="reset" variant="danger">Limpar</b-button>
        </div>
    </b-form>
</template>

<script>
import Swal from "sweetalert2";
import { modifyUserPassword, changePasswordAction } from "./../configs/services";
import Bus from "./../configs/bus";

export default {
    name: "Signup",
    props: ['id'],
    data() {
        return {
            form: {
                password: "",
                password_confirmation: ""
            },
            show: true
        };
    },
    methods: {
        goback(){
            window.history.back();
        },

        onSubmit(evt) {
            Bus.$emit("toggle", null);

            let action = null;
            
            if(!this.$props.id){
                action = changePasswordAction(this.form);
            }else{
                action = modifyUserPassword(this.$props.id, this.form);
            }
            
            //changePasswordAction(this.form)
            
            action
            .then(item => {
                console.log(item);
                Swal.fire("Sucesso!", "Senha modificada com sucesso", "success");
            })
            .catch(this.errorHandler)
            .then(function() {
                Bus.$emit("toggle", null);
            });
        },

        onReset(evt) {
            // Reset our form values
            this.form = {
                password: "",
                password_confirmation: ""
            };
            // Trick to reset/clear native browser form validation state
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
            });
        }
    }
}
</script>

<style>
.main-form {
    background-color: #ddcecb;
}
</style>